import { DeadlineTypeEnum } from '@zaoblako/shared/common/enums/deadline.type.enum';
import { DeadlineTypeEnumI18n } from '@zaoblako/shared/common/i18n/deadline.type.enum.i18n';
import { DeadlineMonthTypeEnum } from '@zaoblako/shared/common/enums/deadline.month.type.enum';
import { DeadlineMonthTypeEnumI18n } from '@zaoblako/shared/common/i18n/deadline.month.type.enum.i18n';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CommonDtoKeysEnum } from '@zaoblako/shared/common/enums/common-dto-keys.enum';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';

import * as yup from 'yup';

/** Deadline settings create/update request - DTO signature */
export interface DeadlineFormInterface {
  /** Type of deadline */
  type: DeadlineTypeEnum;
  /**
   * How many days need to add (defined only when {@link DeadlineFindInterface.type}
   * property equals {@link DeadlineTypeEnum.RELATIVE}
   */
  daysAfter?: number;
  /**
   * Which day of month need to set (defined only when {@link DeadlineFindInterface.type}
   * property equals {@link DeadlineTypeEnum.ABSOLUTE}
   */
  dayOfMonth?: number;
  /**
   * Which month need to use (defined only when {@link DeadlineFindInterface.type}
   * property equals {@link DeadlineTypeEnum.ABSOLUTE}
   */
  monthType?: DeadlineMonthTypeEnum;
}

/** Deadline settings create/update request - DTO schema */
export const DeadlineFormDto = SerdeDtoClass.create<DeadlineFormInterface>(CommonDtoKeysEnum.DEADLINE_FORM_DTO, {
  type: {
    label: 'Тип дедлайна',
    hint: 'Определяет стратегию вычисления даты дедлайна',
    serializer: commonEnumValidator(DeadlineTypeEnum, DeadlineTypeEnumI18n),
  },
  daysAfter: {
    optional: context => (<DeadlineFormInterface>context.value)?.type !== DeadlineTypeEnum.RELATIVE,
    label: 'Дней спустя',
    hint: 'Количество дней, которые нужно добавить к дате. Определен только если тип дедлайна равен `DeadlineTypeEnum.RELATIVE`',
    serializer: yup
      .number()
      .integer('Число дней должно быть целым числом')
      .min(0, 'Число дней должно быть больше или равно нулю'),
  },
  dayOfMonth: {
    optional: context => (<DeadlineFormInterface>context.value)?.type !== DeadlineTypeEnum.ABSOLUTE,
    label: 'Дней спустя',
    hint: 'День месяца. Определен только если тип дедлайна равен `DeadlineTypeEnum.ABSOLUTE`.',
    serializer: yup
      .number()
      .integer('День месяца должен быть целым числом')
      .min(1, 'День месяца должен быть числом от 1 до 31')
      .max(31, 'День месяца должен быть числом от 1 до 31'),
  },
  monthType: {
    optional: context => (<DeadlineFormInterface>context.value)?.type !== DeadlineTypeEnum.ABSOLUTE,
    label: 'Тип месяца',
    hint: 'Определяет, какой месяц надо использовать для дедлайна. Определен только если тип дедлайна равен `DeadlineTypeEnum.ABSOLUTE`.',
    serializer: commonEnumValidator(DeadlineMonthTypeEnum, DeadlineMonthTypeEnumI18n),
  },
})
